import { FC, ReactElement } from 'react';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import {
  common,
  custom2,
  error,
  grey,
  normalText,
  other,
  secondary,
} from 'assets/colors/colors';

type Variant = 'primary' | 'secondary' | 'error' | 'light';

export interface ITooltip extends TooltipProps {
  children: ReactElement;
  variant?: Variant;
  boxShadow?: boolean;
  maxWidth?: string;
}

const variantTextColor: Record<Variant, string> = {
  primary: common.white,
  secondary: common.white,
  error: error.main,
  light: normalText.main,
};

const variantBackgroundColor: Record<Variant, string> = {
  primary: grey.g700,
  secondary: secondary.main,
  error: custom2.main,
  light: common.white,
};

export const Tooltip: FC<ITooltip> = ({
  children,
  arrow,
  title,
  variant = 'primary',
  boxShadow = false,
  maxWidth = '300px',
  ...rest
}) => (
  <MuiTooltip
    title={title}
    arrow={arrow}
    PopperProps={{
      sx: {
        zIndex: '10000001 !important',
      },
    }}
    componentsProps={{
      tooltip: {
        sx: {
          color: variantTextColor[variant],
          background: variantBackgroundColor[variant],
          boxShadow: boxShadow
            ? `8px 8px 8px 8px ${other.customBoxShadow}`
            : 'none',
          maxWidth,
        },
      },
      arrow: {
        sx: {
          color: variantBackgroundColor[variant],
        },
      },
    }}
    {...rest}
  >
    {children}
  </MuiTooltip>
);
